/*! Wi-media - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */
var url_category, url_category_edit, url_category_save, url_category_delete, url_media_download, url_media_save_order, url_media_delete, url_media_unlink, url_media_move, url_media_get, url_media_upload, url_media_add_referral, url_media_insert, url_media_edit, url_media_main, url_media_referral_type, url_media_save, url_media_active, url_save_link;

+function ($) {
    'use strict';
    var wiMedia = window.wiMedia;

    window.wiMedia = {
        init: function () {
            wiMedia.btn.init();
            $(function () {
                if ($('.wi-media').length) {
                    wiMedia.get.files();
                }
                setTimeout(function () {
                    setInterval(function () {
                        $('tbody.media').find('tr').each(function () {
                            var th = $(this);
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0) {
                                wiMedia.get.file(file_id);
                            }
                        });
                        $('.tasks-media').each(function () {
                            var th = $(this);
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0) {
                                wiVars.set.media.from.object(th);
                                wiMedia.get.file(file_id);
                            }
                        });
                        $('.invoices-media').each(function () {
                            var th = $(this);
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0) {
                                wiVars.set.media.from.object(th);
                                wiMedia.get.file(file_id);
                            }
                        });
                        $('.comments-media').each(function () {
                            var th = $(this);
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0) {
                                wiVars.set.media.from.object(th);
                                wiMedia.get.file(file_id);
                            }
                        });
                        $('.chat-media').each(function () {
                            var th = $(this);
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0) {
                                wiVars.set.media.from.object(th);
                                wiMedia.get.file(file_id);
                            }
                        });
                        $('.media.media-grid').find('.col-xs-6').each(function () {
                            var th = $(this);
                            var parent = $(this).parent().parent();
                            var status = th.data('status');
                            var file_id = th.data('id');
                            if (status === 0 && th.is(':visible')) {
                                wiMedia.get.file(file_id, parent);
                            }
                        });
                    }, 2000);
                }, 2000);
            });
        },
        get: {
            file: function (file_id, parent) {
                var data;
                if (parent) {
                    data = {
                        file_id: file_id,
                        language_id: language_id,
                        category_id: category_id,
                        referral_id: parent.attr('data-referral-id'),
                        referral_type: parent.attr('data-referral-type'),
                        subreferral_id: parent.attr('data-subreferral-id'),
                        subreferral_type: parent.attr('data-subreferral-type'),
                        target_referral_id: parent.attr('data-referral-id'),
                        target_referral_type: parent.attr('data-referral-type'),
                        target_subreferral_id: parent.attr('data-subreferral-id'),
                        target_subreferral_type: parent.attr('data-subreferral-type'),
                        media_type: media_type,
                        media_view: media_view,
                        media_manager: media_manager_input,
                        csrf_wicode: csrf_value
                    };
                } else {
                    wiVars.set.variables();
                    data = {
                        file_id: file_id,
                        language_id: language_id,
                        category_id: category_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        media_type: media_type,
                        media_view: media_view,
                        media_manager: media_manager_input,
                        csrf_wicode: csrf_value
                    };
                }
                $.get(url_media_get, data, function (respond) {
                    $('.file_' + file_id).replaceWith(respond.file);
                    wiMedia.set.plugins();
                });
            },
            tabFiles: function (el) {
                wiVars.set.from.object(el);
                wiVars.set.media.from.object(el);

                el.attr('data-ajax-loaded', true);
                wiMedia.get.files();
                wiMedia.media.uncheck();
            },
            files: function () {
                wiVars.set.variables();
                $.get(url_media_get, {
                    language_id: language_id,
                    category_id: category_id,
                    referral_id: media_referral_id,
                    referral_type: media_referral_type,
                    subreferral_id: media_subreferral_id,
                    subreferral_type: media_subreferral_type,
                    target_referral_id: referral_id,
                    target_referral_type: referral_type,
                    target_subreferral_id: subreferral_id,
                    target_subreferral_type: subreferral_type,
                    media_type: media_type,
                    media_view: media_view,
                    media_manager: media_manager_input,
                    csrf_wicode: csrf_value
                }, function (respond) {
                    if ($('#media-' + media_subreferral_type + '-' + media_subreferral_id).length) {
                        $('#media-' + media_subreferral_type + '-' + media_subreferral_id).html(respond.media);
                    } else if (media_manager_input === 'true') {
                        $('#media_manager').html(respond.media);
                        $('#media_manager_breadcrumb .breadcrumb').html(respond.breadcrumbs);
                    } else
                    {
                        $('#media-wrapper').html(respond.media);
                        $('#media_breadcrumb .breadcrumb').html(respond.breadcrumbs);
                    }
                    wiMedia.set.plugins();                    
                    if (typeof wiActivity !== 'undefined') {
                        wiActivity.get(referral_id, referral_type);
                    }
                });

            }
        },
        btn: {
            init: function () {
                $(document).on('hidden.bs.modal', '#media_modal', function () {
                    wiVars.set.variable('media_manager_input', 'false');
                    wiMedia.get.files();
                });
                $(document).on('show.bs.collapse', '.tab-section-media', function () {
                    var target = $(this).attr('data-target');
                    wiMedia.get.tabFiles($(target));
                });
                $(document).on('show.bs.tab', '.wiMedia', function () {
                    var target = $(this).attr('data-target');
                    var ajaxloaded = $(target).attr('data-ajax-loaded');
                    if (ajaxloaded === 'false') {
                        $(target).attr('data-ajax-loaded', true);
                        wiMedia.get.files();
                    }
                    wiMedia.media.uncheck();
                });
                $(document).on('hidden.bs.collapse', '.collapse', function () {
                    wiMedia.media.uncheck();
                });
                $(document).off('click', '.media-manager').on('click', '.media-manager', function (event) {
                    event.preventDefault();
                    wiVars.set.variable('media_manager_input', 'true');
                    wiVars.set.variables();
                    wiModal.get({
                        modal: 'media_modal',
                        module: 'media',
                        language_id: language_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        media_manager: media_manager_input
                    });
                });
                $(document).off('click', '.media-uploader').on('click', '.media-uploader', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (referral_category_id) {
                        wiVars.set.variable('category_id', referral_category_id);
                    }
                    var target = $(this).attr('data-target');
                    if (target && $(target)) {
                        wiVars.set.from.object($(target));
                    }
                    wiVars.set.variables();

                    wiModal.get({
                        modal: 'uploader',
                        module: 'media',
                        remove: 'no'
                    });
                });
                $(document).off('click', '.media-link-uploader').on('click', '.media-link-uploader', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (referral_category_id) {
                        wiVars.set.variable('category_id', referral_category_id);
                    }
                    var target = $(this).attr('data-target');
                    if (target && $(target)) {
                        console.log(target, $(target))
                        wiVars.set.from.object($(target));
                    }
                    wiVars.set.variables();

                    wiModal.get({
                        modal: 'add_link',
                        module: 'media',
                        language_id: language_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        category_id: category_id
                    });
                });
                $(document).off('click', '.link-edit').on('click', '.link-edit', function (event) {
                    event.preventDefault();
                    var file_id = $(this).attr('data-file-id');
                    wiModal.get({
                        modal: 'edit_link',
                        module: 'media',
                        language_id: language_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        category_id: category_id,
                        file_id: file_id
                    });
                });
                $(document).off('click', '#media_link_save_btn').on('click', '#media_link_save_btn', function (event) {
                    event.preventDefault();
                    var btn = $(this);
                    var modal = btn.attr('data-modal');
                    var icon = btn.find('.fa');
                    icon.toggleClass('hidden');
                    var form_data = $("#form_media_link").serialize();
                    $.ajax({
                        url: url_save_link,
                        type: 'POST',
                        data: form_data,
                        success: function (jData) {
                            btn.prop("disabled", false);
                            icon.toggleClass('hidden');
                            if (jData.status === 'success') {
                                wiMedia.get.files();
                                $(modal).modal('hide');
                            }
                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        }
                    });
                });
                $(document).on('shown.bs.modal', '#edit_file', function () {
                    activateEditor('.extra-editor');
                });
                $(document).on('hidden.bs.modal', '#edit_file', function () {
                    removeEditor('.extra-editor');
                });
                $(document).on('hide.bs.modal', '#edit_file', function () {
                    tinyMCE.editors = [];
                });
                $(document).off('click', '.media-edit').on('click', '.media-edit', function (event) {
                    event.preventDefault();
                    var file_id = $(this).attr('data-file-id');
                    wiModal.get({
                        modal: 'edit_file',
                        module: 'media',
                        language_id: language_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        category_id: category_id,
                        file_id: file_id
                    });
                });
                $(document).off('click', '#media_file_save_btn').on('click', '#media_file_save_btn', function (event) {
                    event.preventDefault();
                    var btn = $(this);
                    var modal = btn.attr('data-modal');
                    var icon = btn.find('.fa');
                    icon.toggleClass('hidden');
                    var form_data = $("#form_media_file").serialize();
                    $.ajax({
                        url: url_media_save,
                        type: 'POST',
                        data: form_data,
                        success: function (jData) {
                            btn.prop("disabled", false);
                            icon.toggleClass('hidden');
                            if (jData.status === 'success') {
                                wiMedia.get.files();
                                $(modal).modal('hide');
                            }
                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        }
                    });
                });
                $(document).on('click', '#media-save-order', function (event) {
                    var btn = $(this);
                    if (btn.children('.fa').hasClass('fa-check')) {
                        btn.children('.fa').removeClass('fa-check');
                    }
                    if (!btn.children('.fa').hasClass('fa-spin')) {
                        btn.children('.fa').removeClass('hidden').addClass('fa-spinner').addClass('fa-spin');
                    } else {
                        btn.children('.fa').addClass('hidden').removeClass('fa-spinner').removeClass('fa-spin');
                    }
                    var oSortable = [];
                    document.querySelectorAll('.sortable').forEach(function (el) {
                        if (el._sortable) { oSortable = oSortable.concat(el._sortable.toArray()); }
                    });
                    $.ajax({
                        url: url_media_save_order,
                        type: 'POST',
                        data: {
                            sortable: oSortable,
                            csrf_wicode: csrf_value
                        },
                        success: function (jData) {
                            btn.prop("disabled", false);
                            if (!btn.children('.fa').hasClass('fa-check')) {
                                btn.children('.fa').addClass('fa-check');
                            }
                            if (btn.children('.fa').hasClass('fa-spin')) {
                                btn.children('.fa').removeClass('fa-spinner').removeClass('fa-spin');
                            }
                            setTimeout(function () {
                                btn.children('.fa').removeClass('fa-check').addClass('hidden');
                            }, 2000);
                            wiAlerts.add(jData.status, jData.title, jData.msg);
                        }
                    });
                });
                $(document).on('change', "#checkall", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    $(".media-checkbox").prop('checked', $(this).prop("checked"));
                });
                $(document).on('click', ".category-open", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var id = $(this).data('id');
                    category_id = id;
                    if ($('#category_id').length) {
                        $('#category_id').val(category_id);
                    }
                    wiMedia.get.files();
                });
                $(document).on('click', ".category-create", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    wiModal.get({
                        modal: 'create',
                        module: 'media/media_category',
                        parent_id: category_id,
                        language_id: language_id,
                        referral_id: media_referral_id,
                        referral_type: media_referral_type,
                        subreferral_id: media_subreferral_id,
                        subreferral_type: media_subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type
                    });
                });
                $(document).on('click', "#category_create_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#category_create_form").serialize();
                    $.ajax({
                        url: url_category_save,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiMedia.get.files();
                                $('#create').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });

                });
                $(document).on('click', ".category-edit", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var id = $(this).data('id');
                    wiModal.get({
                        modal: 'edit',
                        module: 'media/media_category',
                        category_id: id
                    });

                });
                $(document).on('click', "#category_edit_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#category_edit_form").serialize();
                    $.ajax({
                        url: url_category_save,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiMedia.get.files();
                                $('#edit').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });
                });
                $(document).on('click', ".category-delete", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var id = $(this).data('id');
                    wiModal.get({
                        modal: 'delete_confirmation',
                        module: 'media/media_category',
                        category_id: id
                    });

                });
                $(document).on('click', "#category_delete_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#category_delete_form").serialize();
                    $.ajax({
                        url: url_category_delete,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiMedia.get.files();
                                $('#delete_confirmation').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });
                });
                $(document).on('click', ".media-move", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var file_id = $(this).data('id');
                    wiMedia.media.move(file_id);
                });
                $(document).on('click', "#media_move_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#media_move_form").serialize();
                    $.ajax({
                        url: url_media_move,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiMedia.get.files();
                                $('#move_modal').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });

                });

                $(document).on('click', ".media-select-all", function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var th = $(this);
                    var wrapper = th.parent().parent().parent();
                    if (th.hasClass('is-all-selected')) {
                        th.removeClass('is-all-selected');
                        th.find('span').text(th.data('select-text'));
                        wrapper.find('.media-checkbox').prop('checked', false);
                    } else {
                        $('.media-select-all').removeClass('is-all-selected').each(function () {
                            $(this).find('span').text($(this).data('select-text'));
                        });
                        wrapper.find('.media-checkbox').prop('checked', false);
                        th.addClass('is-all-selected');
                        th.find('span').text(th.data('deselect-text'));
                        wrapper.find('.media-checkbox').prop('checked', true);
                    }

                });
                $(document).on('submit', ".bulkMediaform", function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var funcs = {
                        'download': wiMedia.media.download,
                        'delete': wiMedia.media.remove
                    };
                    var action = '';
                    var actionEl = this.querySelector('[name="bulk_action"]');
                    if (actionEl) {
                        action = actionEl.value;
                    }
                    if (action && wiMedia.media.checked().length) {
                        funcs[action]();
                        wiMedia.media.uncheck();
                    }
                    // add elst and show info alert with something like 'please select first'
                });

                $(document).on('submit', "#media_bulk_action_form", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var funcs = {
                        'download': wiMedia.media.download,
                        'move': wiMedia.media.move,
                        'delete': wiMedia.media.remove
                    };
                    var action = $('#media_bulk_action').val();
                    if (action) {
                        funcs[action]();
                    }
                    $('#media_bulk_action').val('');
                });
                $(document).on('click', ".media-download", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var file_id = $(this).data('id');
                    wiMedia.media.download(file_id);

                });
                $(document).on('click', ".media-delete", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var file_id = $(this).data('id');
                    wiMedia.media.remove(file_id);

                });
                $(document).on('click', "#media_delete_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#media_delete_form").serialize();
                    $.ajax({
                        url: url_media_delete,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                // Remove files from DOM
                                let fileIds = $('#media_delete_form input[name="file_id"]').map(function () {
                                    return $(this).val();
                                }).get();

                                // If not an array, normalize to one
                                fileIds = Array.isArray(fileIds) ? fileIds : [fileIds];

                                fileIds.forEach(id => {
                                    $(`.file_${id}`).remove();
                                });
                
                                wiMedia.get.files();
                                $('#delete_confirmation').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });
                });
                $(document).on('click', ".media-unlink", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var file_id = $(this).data('id');
                    wiMedia.media.unlink(file_id);

                });
                
                $(document).on('click', ".media-remove-file", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    const fileId = $(this).data('id');
                    if (fileId) {
                        wiMedia.media.remove(fileId);
                    }
                });
                
                $(document).on('click', "#media_unlink_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var form_data = $("#media_unlink_form").serialize();
                    $.ajax({
                        url: url_media_unlink,
                        type: 'POST',
                        data: form_data,
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                wiMedia.get.files();
                                $('#delete_confirmation').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });
                });
                $(document).on('click', "#media_modal_btn", function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var file_id = wiMedia.media.checked();

                    $.ajax({
                        url: url_media_add_referral,
                        type: 'POST',
                        data: {
                            file_id: file_id,
                            language_id: language_id,
                            category_id: category_id,
                            referral_id: media_referral_id,
                            referral_type: media_referral_type,
                            subreferral_id: media_subreferral_id,
                            subreferral_type: media_subreferral_type,
                            target_referral_id: referral_id,
                            target_referral_type: referral_type,
                            target_subreferral_id: subreferral_id,
                            target_subreferral_type: subreferral_type,
                            csrf_wicode: csrf_value
                        },
                        success: function (response) {
                            $('.wicode-modal .validation').html('');
                            if (response.status === 'success') {
                                $('#media_modal').modal('hide');
                            } else {
                                $('.wicode-modal .validation').append(response.msg);
                            }
                        }
                    });

                });
                $(document).on('change', '.file-active', function (event) {
                    event.preventDefault();

                    var active = 0;
                    if ($(this).is(':checked')) {
                        active = $(this).val();
                    }

                    var file_id = $(this).data('id');

                    $.post(
                            url_media_active,
                            {
                                csrf_wicode: csrf_value,
                                referral_id: referral_id,
                                referral_type: referral_type,
                                subreferral_id: subreferral_id,
                                subreferral_type: subreferral_type,
                                file_id: file_id,
                                active: active
                            },
                            function (data) { }
                    );

                });
                $(document).on('change', '.file-type', function (event) {
                    event.preventDefault();
                    var type = $(this).val();
                    var file_id = $(this).data('id');
                    if (file_id) {
                        $.post(
                                url_media_referral_type,
                                {
                                    csrf_wicode: csrf_value,
                                    referral_id: referral_id,
                                    referral_type: referral_type,
                                    subreferral_id: subreferral_id,
                                    subreferral_type: subreferral_type,
                                    file_id: file_id,
                                    type: type
                                },
                                function (data) { }
                        );
                    }
                });

                $(document).on('click', '.file-make-main', function (event) {
                    event.preventDefault();

                    var file_link_id = $(this).attr('data-id');

                    $.post(
                            url_media_main,
                            {
                                file_link_id: file_link_id,
                                referral_id: referral_id,
                                referral_type: referral_type,
                                subreferral_id: subreferral_id,
                                subreferral_type: subreferral_type,
                                csrf_wicode: csrf_value
                            },
                            function (data) {
                                wiMedia.get.files();
                            }
                    );
                });
                $(document).on('show.bs.modal', '#view_media', function () {
                    wiComments.get.comments();
                    wiPlugins.refresh();
                });
                $(document).on('click', '.media-view', function (event) {
                    event.preventDefault();
                    var file_id = $(this).attr('data-file-id');
                    wiVars.set.from.object($(this));
                    comment_referral_id = file_id;
                    comment_referral_type = 'media';
                    wiVars.set.variable('comment_referral_id', comment_referral_id);
                    wiVars.set.variable('comment_referral_type', comment_referral_type);
                    wiModal.get({
                        modal: 'view_media',
                        module: 'media',
                        url: 'media',
                        language_id: language_id,
                        referral_id: referral_id,
                        referral_type: referral_type,
                        subreferral_id: subreferral_id,
                        subreferral_type: subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        file_id: file_id
                    });
                });

                $(document).on('click', '.media-pagin', function (event) {
                    event.preventDefault();
                    var file_id = $(this).attr('data-file-id');
                    wiVars.set.from.object($(this));
                    comment_referral_id = file_id;
                    comment_referral_type = 'media';
                    wiVars.set.variable('comment_referral_id', comment_referral_id);
                    wiVars.set.variable('comment_referral_type', comment_referral_type);
                    wiModal.get({
                        modal: 'view_media_file',
                        module: 'media',
                        url: 'media',
                        language_id: language_id,
                        referral_id: referral_id,
                        referral_type: referral_type,
                        subreferral_id: subreferral_id,
                        subreferral_type: subreferral_type,
                        target_referral_id: referral_id,
                        target_referral_type: referral_type,
                        target_subreferral_id: subreferral_id,
                        target_subreferral_type: subreferral_type,
                        file_id: file_id
                    });
                });

                $(document).on('shown.bs.modal', '#media_modal', function () {
                    wiVars.set.variable('media_manager_input', 'true');
                    wiMedia.get.files();
                });
                $(document).on('shown.bs.modal', '#editor_modal', function () {
                    $(".media-checkbox").prop('checked', false);
                    wiVars.set.variable('media_manager_input', 'true');
                    wiMedia.get.files();
                });
                $(document).on('shown.bs.modal', '#wysiwyg_modal', function () {
                    $(".media-checkbox").prop('checked', false);
                    wiVars.set.variable('media_manager_input', 'true');
                    wiMedia.get.files();
                });
            }
        },
        media: {
            sortable: function () {
                $(function () {
                    document.querySelectorAll('.media.sortable').forEach(function (el) {
                        el._sortable = new Sortable(el, {
                            group: 'media-sortable',
                            animation: 150,
                            dataIdAttr: 'id'
                        });
                    });
                });
            },
            move: function (file_id) {
                if (!file_id) {
                    file_id = wiMedia.media.checked();
                }
                wiModal.get({
                    modal: 'move_modal',
                    module: 'media',
                    file_id: file_id
                });
            },
            download: function (file_id) {
                if (!file_id) {
                    file_id = wiMedia.media.checked();
                }
                wiModal.get({
                    modal: 'downloadModal',
                    module: 'media',
                    file_id: file_id
                });
            },
            remove: function (file_id) {
                if (!file_id) {
                    file_id = wiMedia.media.checked();
                }
                wiModal.get({
                    modal: 'delete_confirmation',
                    module: 'media',
                    file_id: file_id
                });
            },
            unlink: function (file_id) {
                if (!file_id) {
                    file_id = wiMedia.media.checked();
                }
                wiModal.get({
                    modal: 'unlink_module_confirmation',
                    module: 'media',
                    file_id: file_id,
                    referral_id: referral_id,
                    referral_type: referral_type,
                    subreferral_id: subreferral_id,
                    subreferral_type: subreferral_type,
                });
            },
            uncheck: function () {
                $('.media-checkbox').prop('checked', false);
                $('.media-select-all').removeClass('is-all-selected').each(function () {
                    $(this).find('span').text($(this).data('select-text'));
                });
            },
            checked: function (file_id) {
                return $('.media-checkbox:checked').map(function () {
                    return this.value;
                }).get();
            }
        },
        show: {
            media: function (file_id) {

            }
        },
        set: {
            plugins: function () {
                wiMedia.media.sortable();
                wiImages.refresh();
                wiPlugins.refresh();
            }
        }
    };

    $(function () {
        url_category = urls.media + '/category/get';
        url_category_edit = urls.media + '/category/edit';
        url_category_save = urls.media + '/category/save';
        url_category_delete = urls.media + '/category/delete';

        url_media_download = urls.media + '/download';
        url_media_delete = urls.media + '/delete';
        url_media_unlink = urls.media + '/delete';
        url_media_move = urls.media + '/move';
        url_media_get = urls.media + '/get';
        url_media_upload = urls.media + '/upload';
        url_media_edit = urls.media + '/edit';
        url_media_save = urls.media + '/save';
        url_media_save_order = urls.media + '/save_order';
        url_media_main = urls.media + '/main';
        url_media_active = urls.media + '/active';
        url_media_referral_type = urls.media + '/type';

        url_media_add_referral = urls.media + '/add';
        url_media_insert = urls.media + '/media_insert';
        url_save_link = urls.media + '/save_link';
        wiMedia = window.wiMedia;
        wiMedia.init();
    });
}(jQuery);
